import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { ProjectList } from "~root/projects/ProjectList";
import { DefaultContentLayout, DetailsPageContentLayout } from "~shared/layout";

export const ProjectPage: FC = () => {
	return (
		<Routes>
			<Route
				index
				element={
					<DefaultContentLayout>
						<ProjectList />
					</DefaultContentLayout>
				}
			/>
			<Route
				path=":id/*"
				element={
					<DetailsPageContentLayout>
						<div />
					</DetailsPageContentLayout>
				}
			/>
		</Routes>
	);
};
